import React from "react";
import fake_photos from "../../../../images/icons/fake_photos.png";
import { Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { defaultFuncAndData } from "../../../utils/defaultData";
function CardProgressStudents({ elem, indx, isLightTheme = false }) {
  const history = useNavigate();
  return (
    <div className={"member"} key={indx}>
      <div
        className={"study"}
        onClick={() => history(`/backoffice/student-card/${elem.id}`)}
      >
        <img
          src={(elem.user.profile && elem.user.profile.avatar) || fake_photos}
          style={{ borderRadius: 14 }}
          alt=""
        />
        <div className="fio">{elem.user.profile && elem.user.profile.name}</div>
        <Progress
          type="dashboard"
          percent={elem.progress}
          gapDegree={1}
          strokeColor={defaultFuncAndData.calcColorPercentProgress(
            elem.progress
          )}
          width={42}
          height={42}
          format={(percent) => percent}
          trailColor={isLightTheme ? "#E2E8F0" : "#474C5A"}
          strokeWidth={20}
        />
      </div>
    </div>
  );
}

export default CardProgressStudents;
